import React, { useRef } from "react";
import "../../style/HorizontalScroll.css";
import scrollImg from '../../assets/scroll.png'

function HorizontalScroll() {
  const scrollRef = useRef(null);

  return (
    <div className="horizontal-container col-md-8 col-lg-8 col-xl-8">

      <h1 className="mb-3 fw-normal border-bottom text-left pb-2 mb-4">
        Horizontal Scroll
      </h1>
      <div className="horizontal-scroll" ref={scrollRef}>

        <p className="text-justify">
          Lorem Ipsum is simply dummy text of the printing and typesetting
          industry. Lorem Ipsum has been the industry's standard dummy text
          ever since the 1500s.
        </p>

        <p>
          <img
            src={scrollImg}
            alt="example"
            className="scroll-image"
          />
        </p>

        <h3 className="text-left">Why do we use it?</h3>

        <p className="text-justify">
          It is a long established fact that a reader will be distracted by
          the readable content of a page when looking at its layout.
        </p>

        <p className="text-justify">
          The point of using Lorem Ipsum is that it has a more-or-less normal
          distribution of letters.
        </p>

        <p className="text-justify">
          Many desktop publishing packages and web page editors now use
          Lorem Ipsum as their default model text.
        </p>

      </div>

    </div>
  );
}

export default HorizontalScroll;
